import React from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Form, Input, Button, Spin, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
// import ReactGA from 'react-ga';
import { LOGIN, GET_AUTH } from '../../gql/auth';

const LoginForm = () => {
  const history = useHistory();
  const { search } = useLocation();
  const redirect = localStorage.getItem('redirect');
  const [login, { loading: mutationLoading }] = useMutation(LOGIN, {
    update(cache, { data: { login } }) {
      cache.writeQuery({
        query: GET_AUTH,
        data: {
          auth: {
            token: login.token,
            isLoggedIn: true,
            me: login.me,
            loading: false,
          },
        },
      });
      localStorage.setItem('token', login.token);
      history.push(params.redirect ?? redirect ?? '/');
    },
    refetchQueries: [{ query: GET_AUTH }],
  });
  const params = qs.parse(search);

  const { Text } = Typography;

  const onFinish = (input) => {
    login({ variables: { input } });
  };

  return (
    <Spin spinning={mutationLoading}>
      <div style={{ marginBottom: '24px' }}>
        <Text type="secondary">Login with your PMS local account</Text>
      </div>
      <Form name="login" onFinish={onFinish}>
        <Form.Item
          name="netId"
          rules={[
            {
              required: true,
              message: 'Please input your netId!',
            },
          ]}
        >
          <Input
            placeholder="username"
            size="large"
            prefix={<UserOutlined />}
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: 'Please input your password!',
            },
          ]}
        >
          <Input.Password
            placeholder="password"
            size="large"
            prefix={<LockOutlined />}
          />
        </Form.Item>

        <Form.Item>
          <Button shape="round" type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Spin>
  );
};

LoginForm.propTypes = {};

export default LoginForm;
